var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIc24VolumeMax = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "M12 5v14c0 .89-1.077 1.337-1.707.707L6.586 16H3a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.586l3.707-3.707C10.923 3.663 12 4.109 12 5Zm4.12-.475a1 1 0 0 1 1.355-.405C20.232 5.607 22 8.639 22 12c0 3.361-1.768 6.393-4.525 7.88a1 1 0 0 1-.95-1.76C18.63 16.986 20 14.633 20 12s-1.372-4.986-3.475-6.12a1 1 0 0 1-.405-1.355ZM10 7.415 7.707 9.706A1 1 0 0 1 7 10H4v4h3a1 1 0 0 1 .707.293L10 16.586V7.414Zm4.092 1.165a1 1 0 0 1 1.328-.488C16.979 8.813 18 10.314 18 12s-1.021 3.187-2.58 3.908a1 1 0 0 1-.84-1.816C15.451 13.69 16 12.883 16 12s-.549-1.69-1.42-2.092a1 1 0 0 1-.488-1.328Z",
  clipRule: "evenodd"
})));
export default SvgIc24VolumeMax;